import React from 'react';
import Alert from '@amzn/awsui-components-console/alert';
import Box from '@amzn/awsui-components-console/box';
import Button from '@amzn/awsui-components-console/button';
import Modal from '@amzn/awsui-components-console/modal';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import { useTranslation } from 'src/i18n/shim/useTranslation';

interface ClearDraftModalProps {
  visible: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

/**
 * Confirms discarding all unsaved (draft) changes for a string group. Clearing
 * removes the locally-persisted draft (localStorage) and cannot be undone, so
 * the destructive action is gated behind an explicit confirmation — matching
 * the Cancel Translation flow.
 */
const ClearDraftModal: React.FC<ClearDraftModalProps> = ({
  visible,
  onDismiss,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={t('sgd-clear-draft-title')}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button onClick={onDismiss}>{t('sgd-clear-draft-keep')}</Button>
            <Button
              variant="primary"
              onClick={onConfirm}
              className="btn-danger"
            >
              <Box color="text-status-error" fontWeight="bold">
                {t('sgd-clear-draft-confirm')}
              </Box>
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <Alert type="warning">{t('sgd-clear-draft-warning')}</Alert>
    </Modal>
  );
};

export default ClearDraftModal;
